import {Navigate} from 'react-router-dom';

const AdminHome = () => (
  <Navigate to="/admin/login" replace/>
);

export default AdminHome;
